import { TopAreaModeStorageKey } from '@issue-detail/IssueDetailWarper';
import { useRootInstance } from '@issue-detail/utils/useRootInstance';
import { onBeforeMount, onMounted, Ref } from '@vue/composition-api';
import { startIssueDialog } from '@issue-detail/utils/performance';
import { startTransaction } from 'common-module/src/util/sentry/customer-transaction';
import { RecorderState } from '@issue-detail/components/IssueDrawer/Model/recorder';
import { getSystemUrlSource } from "../warper/useUrlIssueIdCheck";

const useListener = (
  target: {
    eventBus: {
      $on: (event: string, callback: Function) => void;
      $off: (event: string, callback: Function) => void;
    };
  },
  event: string,
  handler: Function
) => {
  onMounted(() => {
    target.eventBus.$on(event, handler);
  });

  onBeforeMount(() => {
    target.eventBus.$off(event, handler);
  });
};

export const useIssueDetailEvents = (warper: Readonly<Ref<any>>) => {
  const instance = useRootInstance();

  const ISSUE_EDIT = 'issue:edit';
  const ISSUE_CREATE = 'issue:create';
  const ISSUE_FORCE_CLOSE = 'issue:force:close';
  const ISSUE_OP = 'issue';

  // 关闭 Issue
  useListener(instance, ISSUE_FORCE_CLOSE, () => {
    warper.value?.closeIssue();
  })

  // 编辑 Issue
  useListener(instance, ISSUE_EDIT, (action: any) => {
    startTransaction({
      name: ISSUE_EDIT,
      op: ISSUE_OP
    });
    startIssueDialog();
    warper.value?.showIssue(action.id, action, { commentId: action.commentId });
    instance.$track.send(
      'Issue_Visit',
      {
        source: action.source || getSystemUrlSource() || '网站内部',
        top_state:
          (localStorage.getItem(TopAreaModeStorageKey) as
            | 'normal'
            | 'compact') || 'normal'
      },
      true
    );
  });

  // 创建 Issue
  useListener(instance, 'tool:action', (action: any, data: any) => {
    if (action === 'issue.create') {
      startTransaction({
        name: ISSUE_CREATE,
        op: ISSUE_OP
      });
      startIssueDialog();
      warper.value?.showIssue(null, { data });
    }
  });

  // 预览 IssueType
  useListener(
    instance,
    'issue:preview-issue-type',
    ({ projectId, issueTypeId }: any) => {
      warper.value?.previewIssueType(projectId, issueTypeId);
    }
  );

  // 字段布局更新
  useListener(instance, 'config-field-layout:save', (id: any) => {
    warper.value?.reloadData(id);
  });

  useListener(instance, 'recorder:state', (state: RecorderState) => {
    warper.value?.setRecorderState(state);
  });

  useListener(
    instance,
    'recorder:start',
    (options?: { issueAdd: boolean; issueId: number }, from?: string) => {
      warper.value?.setRecordOptions({
        issueId: options?.issueId,
        from
      });
    }
  );

  // 触发更新
  // initIssueUpdateInterceptor() {
  //   http.httpAxios.interceptors.request.use((config) => {
  //     if (['/issue/update-v2', '/issue/update'].includes(config.url)) {
  //       this.eventBus.$emit('global:issueUpdate', config.data);
  //     }
  //     return config;
  //   });
  // },
};
